module.exports = __webpack_public_path__ + "d79f021974b1f6bc5c21f31689cde94f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Light/OpenSans-Light.svg?v=1.1.0
// module id = 976
// module chunks = 0